import {
  LOAD_PARKINGAREAOUTSIDE,
  LOAD_PARKINGAREAOUTSIDE_PREVIEW,
  LOAD_VEHICLE_PARKINGAREAOUTSIDE,
  LOAD_VEHICLE_TYPE_PARKINGAREAOUTSIDE,
} from './actions'

const initialState = {
  parkingareaoutsideUrl: '',
  vehicleLists: [],
  vehicleTypeLists: [],
  parkingareaoutsideLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PARKINGAREAOUTSIDE.REQUEST:
    case LOAD_PARKINGAREAOUTSIDE_PREVIEW.REQUEST:
      const { loading } = action.payload
      return {
        ...state,
        parkingareaoutsideLoading: loading,
      }
    case LOAD_PARKINGAREAOUTSIDE.SUCCESS:
    case LOAD_PARKINGAREAOUTSIDE_PREVIEW.SUCCESS:
      return {
        ...state,
        parkingareaoutsideUrl: action.payload.data.data,
        parkingareaoutsideLoading: false,
      }
    case LOAD_VEHICLE_PARKINGAREAOUTSIDE.REQUEST:
      const { loading_vehicle } = action.payload
      return {
        ...state,
        parkingareaoutsideLoading: loading_vehicle,
      }
    case LOAD_VEHICLE_PARKINGAREAOUTSIDE.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        parkingareaoutsideLoading: false,
        //  loading: false
      }
    case LOAD_VEHICLE_TYPE_PARKINGAREAOUTSIDE.SUCCESS:
      // console.log(action.payload.data.data);
      return {
        ...state,
        vehicleTypeLists: action.payload.data.data,
      }
    default:
      return state
  }
}
